module.exports = __webpack_public_path__ + "img/oneday1-2.9362ed0a.jpg";